import React from 'react';
import PropTypes from 'prop-types';
import styles from './h5-iframe-modal.less';

class H5IframeModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            hasError: false
        };
        this.handleClose = this.handleClose.bind(this);
        this.handleIframeLoad = this.handleIframeLoad.bind(this);
        this.handleIframeError = this.handleIframeError.bind(this);
        this.handleLoadTimeout = this.handleLoadTimeout.bind(this);
        this.iframeRef = React.createRef();
        this.loadTimeoutId = null;
    }

    componentDidMount() {
        this.attachIframeListeners();
        this.startLoadTimeout();
    }

    componentWillUnmount() {
        this.removeIframeListeners();
        this.clearLoadTimeout();
    }

    startLoadTimeout() {
        // 设置 30 秒超时
        this.loadTimeoutId = setTimeout(() => {
            this.handleLoadTimeout();
        }, 30 * 1000);
    }

    clearLoadTimeout() {
        if (this.loadTimeoutId) {
            clearTimeout(this.loadTimeoutId);
            this.loadTimeoutId = null;
        }
    }

    handleLoadTimeout() {
        const { url } = this.props;

        console.error('[H5IframeModal] iframe load timeout:', {
            url,
            timestamp: new Date().toISOString()
        });
        window._analysisSdk.track('element_show', {
            element_name: `AI工具加载失败提示`,
            target_url: url,
            error_type: '超时'
        });
        this.setState({
            isLoading: false,
            hasError: true
        });
    }

    attachIframeListeners() {
        if (this.iframeRef.current) {
            this.iframeRef.current.addEventListener(
                'load',
                this.handleIframeLoad
            );
            this.iframeRef.current.addEventListener(
                'error',
                this.handleIframeError
            );
        }
    }

    removeIframeListeners() {
        if (this.iframeRef.current) {
            this.iframeRef.current.removeEventListener(
                'load',
                this.handleIframeLoad
            );
            this.iframeRef.current.removeEventListener(
                'error',
                this.handleIframeError
            );
        }
    }

    handleIframeLoad(event) {
        console.log('[H5IframeModal] iframe load event:', {
            url: this.props.url,
            timestamp: new Date().toISOString(),
            event
        });

        // 清除超时定时器
        this.clearLoadTimeout();

        this.setState({
            isLoading: false,
            hasError: false
        });
    }

    handleIframeError(event) {
        const { url } = this.props;

        // 清除超时定时器
        this.clearLoadTimeout();

        // 尝试从 event 中提取错误信息（通常为空或很少）
        let errorDetail = 'iframe错误';
        if (event) {
            // event.type 通常是 'error'
            // event.message 通常不存在或为空（安全限制）
            errorDetail = event.message || event.type || 'iframe错误';
        }

        window._analysisSdk.track('element_show', {
            element_name: `AI工具加载失败提示`,
            target_url: url,
            error_type: errorDetail
        });

        console.error('[H5IframeModal] iframe error event:', {
            url: this.props.url,
            timestamp: new Date().toISOString(),
            event
        });

        this.setState({
            isLoading: false,
            hasError: true
        });
    }

    handleClose() {
        const { url } = this.props;
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    render() {
        const { url } = this.props;
        const { isLoading, hasError } = this.state;

        return (
            <div className={styles.modalOverlay}>
                {isLoading && (
                    <div className={styles.loadingOverlay}>
                        <div className={styles.spinner} />
                        <div className={styles.loadingText}>加载中...</div>
                    </div>
                )}
                {hasError && (
                    <div className={styles.errorOverlay}>
                        <div className={styles.errorIcon}>⚠️</div>
                        <div className={styles.errorText}>页面加载失败</div>
                        <div className={styles.errorSubText}>
                            请检查网络连接或稍后重试
                        </div>
                    </div>
                )}
                <iframe
                    ref={this.iframeRef}
                    className={styles.iframe}
                    src={url}
                    title="H5 Content"
                    style={{ opacity: isLoading || hasError ? 0 : 1 }}
                />
                <button
                    className={styles.closeButton}
                    onClick={this.handleClose}
                >
                    结束互动
                </button>
            </div>
        );
    }
}

H5IframeModal.propTypes = {
    url: PropTypes.string,
    onClose: PropTypes.func.isRequired
};

export default H5IframeModal;
